export const PROPERTY_CLASS = {
  COMMERCIAL: 'COMMERCIAL',
  FREEHOLD: 'FREEHOLD',
}

export const TAB_NAME = {
  DETAIL: 'Detail',
  AREA_ANALYTICS: 'Area & Analytics',
  LOCATION: 'Location',
}

export const LOCKED_CONTENT_TEXT = {
  EMAIL_VERIFY: 'Please verify your email',
  LOGIN_REQUIRED: 'Create an account',
}

export const LISTING_SOURCE = {
  REBGV: 'REBGV',
  VOW: 'VOW',
  RAHB: 'RAHB',
  ITSO: 'ITSO',
  PILLAR9: 'PILLAR9',
}

export const LISTING_SOURCE_TERMS = [
  {
    'id': 1,
    'name': 'VOW',
    'requires_signatory': false,
    'deleted_at': null,
    'created_at': '2022-04-11T16:51:52.000000Z',
    'updated_at': '2022-04-11T16:51:52.000000Z',
  },
  {
    'id': 2,
    'name': 'RAHB',
    'requires_signatory': false,
    'deleted_at': null,
    'created_at': '2022-04-11T16:51:52.000000Z',
    'updated_at': '2022-04-11T16:51:52.000000Z',
  },
  {
    'id': 3,
    'name': 'REBGV',
    'requires_signatory': false,
    'deleted_at': null,
    'created_at': '2022-04-11T16:51:52.000000Z',
    'updated_at': '2022-04-11T16:51:52.000000Z',
  },
  {
    'id': 4,
    'name': 'ITSO',
    'requires_signatory': true,
    'deleted_at': null,
    'created_at': '2022-04-11T16:51:52.000000Z',
    'updated_at': '2022-04-11T16:51:52.000000Z',
  },
  {
    'id': 5,
    'name': 'PILLAR9',
    'requires_signatory': true,
    'deleted_at': null,
    'created_at': '2025-04-24T14:35:19.000000Z',
    'updated_at': '2025-04-24T14:35:19.000000Z',
  },
]
